import {FC} from 'react'
import {Link} from 'react-router-dom'
import {PrivacyContent} from 'features/privacyContent'
import {useCanonicalLink, useMetaDescription, useTitle} from 'shared/lib/meta'
import {text} from 'shared/mirrors/text'

export const AntiTraffickingPolicy: FC = () => {
  useTitle(`${text.main.siteName} Anti Trafficking Policy`)

  useMetaDescription(
    `Please familiarize yourself with the ${text.main.siteName} community rules to understand the standards of behavior and interaction on our platform. These rules are created to ensure a safe and respectful environment for all members of our community. Please review our rules before you begin interacting in our community.`
  )

  useCanonicalLink(
    `https://${window.location.hostname}/anti-trafficking-policy`
  )

  return (
    <PrivacyContent>
      <h1>Anti Trafficking Policy</h1>
      <p>Start date: 13.11.2023</p>
      <h2>{text.main.siteName}'s Goal</h2>
      <p>
        This Anti-Trafficking Policy (hereinafter – the “<b>Policy</b>”) is an
        integral part of the {text.main.siteName} <Link to={'/terms-of-use'}>Terms of Use</Link> (hereinafter – the
        “Terms”) and the <Link to={'/community-rules'}>Community Rules</Link>. Please, consider it while using the
        Services.
      </p>
      <p>
        Go Chatty (hereinafter – “<b>We</b>”, “<b>Company</b>”) highly respects
        human dignity and is extremely committed to elaborate the dating
        service, where everyone will have a constant feeling of safety.
      </p>
      <p>
        This Policy expresses our inner values and sets out requirements to our
        Users in accordance with the the Council of Europe Convention on Action
        against Trafficking in Human Beings, Modern Slavery Act 2015, the
        Trafficking Victims Protection Act of 2000, as amended and other
        internationally binding acts in the sphere of human being protection.
      </p>
      <p>
        We may change this Policy from time to time. Your continuous use of the
        Services means you agree to comply with this Policy. Otherwise, we ask
        you immediately cease your using the Services.
      </p>
      <h2>
        <center>1. Statement</center>
      </h2>
      <p>
        Human trafficking is a modern form of slavery. It is often transnational
        in character and affects both genders and all ages. It may take various
        forms, all of which have in common the deprivation of a person’s liberty
        by another in order to exploit them for personal or commercial gain.
        Therefore, the Company declares no tolerance in this regard.
      </p>
      <p>
        Besides our Users, we expect the same high standards from all of our
        contractors, suppliers and other business partners. As a crucial part of
        our contracting processes, we include specific prohibitions against the
        use of forced, compulsory or trafficked labour, or anyone held in
        slavery or servitude, whether adults or children.
      </p>
      <h2>
        <center>2. Responsibility and Compliance</center>
      </h2>
      <p>
        The Company’s management has overall responsibility for ensuring this
        Policy complies with our legal and ethical obligations, and that all
        those under our control comply with it.
      </p>
      <p>
        The Company on the permanent basis takes the set of measures and steps
        mentioned hereunder to maintain safety environment while you are using
        the Services. Therefore, the Company expects the Users share these
        values while using the Services. Otherwise, they may be subject to
        certain limitations, including the termination of the use of the
        Services.
      </p>
      <h2>
        <center>3. Measures</center>
      </h2>
      <p>
        To achieve the goals of this Policy, the Company has taken, among
        others, the following measures:
      </p>
      <p>
        <u>Moderation by Hand with Moderators:</u> managing team in charge will
        moderate content manually to avoid technical errors. This managing team
        will be subject to the strict inner procedures and policies as well as
        the regular trainings.
      </p>
      <p>
        <u>Hiring Teams of Moderators:</u> several teams of moderators will
        monitor user activity for suspicious behaviour. This will include
        monitoring profiles for any signs of human trafficking, love bombing
        comments as well as manipulative job offers and promises.
      </p>
      <p>
        <u>Surveying Users:</u> we provide a regular survey among the Users to
        gather feedback on whether they feel safe while using the Services, how
        to improve our anti-trafficking policies and procedures and encourage
        our Users to inform us if they observe any kind of suspicious behaviour.
      </p>
      <p>
        <u>Auto-Moderation with Google Cloud Vision Technology:</u> we use
        Google cloud vision technology to auto-moderate content. This will help
        to identify and remove any content that violates this Policy and the
        Community Rules.
      </p>
      <p>
        <u>Reporting Suspicious Activity:</u> users are encouraged to report any
        suspicious activity. This includes individuals who ask for explicit
        photographs or videos, individuals who ask for money or gifts,
        individuals who want to meet in private or secluded locations,
        individuals who want to move the conversation off the dating app or
        site, and individuals who refuse to share personal information.
      </p>
      <p>
        To report suspicious activity, please use red button in the right corner
        and press “report abuse”. Our moderators will review your report and
        respond appropriately. The Users are also allowed to block user by
        pressing the respective button in the right corner and he\she will be
        prohibited to reach the respective user.
      </p>
      <p>
        <u>Action Taken on Reports:</u> we will review all reports of suspicious
        activity and take appropriate action. This may include notifying law
        enforcement, blocking the profile, and other measures as necessary. We
        work closely with governments, regulators, law enforcement,
        non-governmental organizations, charities, and other companies in the
        fight against human trafficking.
      </p>
      <h2>
        <center>Alarm to Transparency</center>
      </h2>
      <p>
        We aim to encourage openness and will support anyone who raises genuine
        concerns in good faith under this policy, even if they turn out to be
        mistaken. We are committed to ensuring no one suffers any detrimental
        treatment as a result of reporting in good faith their suspicion that
        modern slavery of whatever form is or may be taking place in any part of
        our own business. Detrimental treatment includes dismissal, disciplinary
        action, threats or other unfavourable treatment connected with raising a
        concern. If you believe that you have suffered any such treatment, you
        should inform us immediately.
      </p>
      <h2>
        <center>Other</center>
      </h2>
      <p>
        Should some issues occur, you may contact us at: {text.main.supportMail}
        .
      </p>
      <p>
        <b>{text.main.siteName}</b> means companies that operate the GoChatty
        service, that are: Entertechia OÜ, Harju maakond, Tallinn, Lasnamäe
        linnaosa, Peterburi tee 53, 11415 and its affiliates, that are: NETTERO
        LIMITED, Suite 23021 8 Shepherd Market, Mayfair, London, United Kingdom,
        W1J 7JY, Infora Limited, SUITE 4.3.02, BLOCK 4 EUROTOWERS GIBRALTAR,
        GX11 1AA, GIBRALTAR and Infora Limited Canada 45b West Wilmot Street,
        201, Richmond Hill, Ontario, Canada, L4B 2P3.
      </p>
    </PrivacyContent>
  )
}
export default AntiTraffickingPolicy
